import Constants from 'config/Constants';
import { ROUTES } from 'config/routes';
import { useUserProfile } from 'hooks/useUserProfile';
import { actions } from 'pages/documents_v2/config/views';
import { useGetDocumentUser } from 'pages/documents_v2/hooks/useGetDocumentUser';
import { Alert } from 'react-bootstrap';
import { BoxArrowUpRight, InfoSquare } from 'react-bootstrap-icons';
import { generatePath, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * @param {number} areaId
 * @param {number} documentId
 */
export function TableBlock({ areaId, documentId }) {
    const { t } = useTranslation();
    const userProfile = useUserProfile();
    const documentUser = useGetDocumentUser(userProfile.userId, documentId);
    const editAreaMatch = useRouteMatch(ROUTES.documents.editArea);

    const showLinkToAreaBtn = editAreaMatch === null && documentUser;

    const urlToArea = generatePath(ROUTES.documents.editArea, {
        documentId,
        view: documentUser.role === Constants.userDocumentRole.spectator ? actions.VIEW : actions.EDIT,
        areaId,
    });

    return (
        <div className="p-4">
            <Alert variant="primary">
                <InfoSquare className="mr-2" />
                {showLinkToAreaBtn ? (
                    <>
                        {t('ai:tableBlock.content')}{' '}
                        <a href={urlToArea} target="_blank" rel="noopener noreferrer">
                            {t('ai:tableBlock.inArticle')} <BoxArrowUpRight size={10} className="mb-1" />
                        </a>
                        .
                    </>
                ) : (
                    <>{t('ai:tableBlock.content')}</>
                )}
            </Alert>
        </div>
    );
}
